/* eslint-disable react/jsx-props-no-spreading */
import { ChipProps, Chip as MuiChip, chipClasses } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import React, { forwardRef } from 'react';

type Props = { selected?: boolean; error?: boolean } & ChipProps;

export const Chip = forwardRef<HTMLDivElement, Props>(({ selected, error, ...props }, ref) => (
  <MuiChip
    clickable
    ref={ref}
    icon={
      selected ? (
        <DoneIcon sx={{ color: '#FFFFFF !important', width: '18px', m: '0px !important', mr: '8px !important' }} />
      ) : undefined
    }
    sx={{
      [`& .${chipClasses.label}`]: {
        p: '0px',
      },
      [`& .${chipClasses.deleteIcon}`]: {
        color: error ? '#FFFFFF' : undefined,
        m: '0px',
        ml: '6px',
      },
      py: '8px',
      px: '12px',
      backgroundColor: (theme) => {
        if (error) return theme.palette.error.dark;
        if (selected) return theme.palette.secondary.main;
        return undefined;
      },
      '&:hover': {
        backgroundColor: (theme) => {
          if (error) return theme.palette.error.dark;
          if (selected) return theme.palette.secondary.main;
          return undefined;
        },
      },
      color: selected || error ? '#FFFFFF' : undefined,
    }}
    {...props}
  />
));
